import { render } from "./Cursor.vue?vue&type=template&id=21d6cd68&scoped=true&ts=true"
import script from "./Cursor.vue?vue&type=script&lang=ts"
export * from "./Cursor.vue?vue&type=script&lang=ts"

import "@/components/Shared/Cursor/style.scss?vue&type=style&index=0&id=21d6cd68&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21d6cd68"]])

export default __exports__